<template>
    <div id="container">
<div id="content">
            <el-form v-if="semesters.length" class="term-select" label-position="left">
                <el-form-item label="Term:" >
                    <el-select style="width:150px;" size="mini" v-model="semesterId" @change="getRequests">
                        <el-option v-for="semester in semesters" :key="semester.id" :value="semester.id" :label="semester.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <h1>Current E-Text requests by course - Reading lists received</h1>
            <etext-service-nav selected="active-services"></etext-service-nav>
            <p>These E-Text requests are current but may need additional media entered. To enter media information, click on the course name.</p>
            <el-table :default-sort="{prop: 'class_name', order: 'ascending'}" :data="requests">
                <el-table-column label="Course" prop="class_name" sortable :sort-orders="['ascending', 'descending']" width="185">
                    <template slot-scope="scope">
                        <a :href="'/etext-service/show/' + scope.row.id">{{ scope.row.class_name }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="Student" prop="student_name" sortable :sort-orders="['ascending', 'descending']" width="215">
                    <template slot-scope="scope">
                        <a :href="'/student/services/' + scope.row.student_id">{{ scope.row.student_name }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="Received required reading list" prop="received_required_reading_list_date" sortable :sort-orders="['ascending', 'descending']" width="130">
                    <template slot-scope="scope">{{ scope.row.received_required_reading_list_date | formatDateMD }}</template>
                </el-table-column>
                <el-table-column label="Accommodations" prop="accommodations" sortable :sort-orders="['ascending', 'descending']">
                    <template slot-scope="scope">
                        <template v-for="accommodation in scope.row.accommodations">
                            {{ accommodation.name }}<template v-if="accommodation.description"> - {{ accommodation.description }}</template><template v-if="accommodation.comment"> - <span v-html="accommodation.comment" :key="accommodation.id"></span></template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <p v-if="total">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ({{ total }} records)</p>
        </div>
        </div>
</template>

<script>
    import axios from 'axios'

    export default {
        metaInfo () {
            return {
                title: "Current E-Text requests by course - Reading lists received"
            }
        },
        components: {
        },
        data () {
            return {
                requests: [],
                semesters: [],
                semesterId: null,
                total: null
            }
        },
        methods: {
            load: function() {
                axios.get('/api/simple/get-current-and-past-semesters')
                    .then(response => {
                        this.semesters = response.data.rows;
                        for(var i = 0; i < this.semesters.length; i++){
                            if(this.semesters[i].is_current){
                                this.semesterId = this.semesters[i].id;
                            }
                        }
                        this.getRequests();
                    });
            },
            getRequests: function() {
                axios.get('/api/etext-service/reading-lists-received/', {params: {semester_id: this.semesterId}})
                    .then(response => {
                        if(response.data.success) {
                            this.requests = response.data.rows;
                            this.total = response.data.total;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            }
        },
        created () {
            this.load();
        }
    }
</script>
<style scoped>
    .term-select {
        width: 250px;
        float:right;
    }
    .el-table th {
        vertical-align: top;
    }
</style>
